import React from "react";
import { getApiBaseUrl } from "../services/backendApi";

/** Redirect SPA /demo/dashboard → API-hosted walkthrough page. */
const DemoWalkthroughRedirect: React.FC = () => {
  React.useEffect(() => {
    window.location.replace(`${getApiBaseUrl()}/demo/dashboard`);
  }, []);

  return (
    <div style={{ padding: "2rem", fontFamily: "system-ui, sans-serif" }}>
      <p>Redirecting to demo walkthrough on the API server…</p>
      <p>
        If nothing happens, open{" "}
        <a href={`${getApiBaseUrl()}/demo/dashboard`}>{getApiBaseUrl()}/demo/dashboard</a>
      </p>
    </div>
  );
};

export default DemoWalkthroughRedirect;
